// Formato de miles para inputs de precio (COP/USD) en el Cotizador Manual.
// Compartido por HotelListaInput.vue y los inputs de precio que no usan ese
// componente (tarifa por acomodación de Costa, hoteles de Tailandia/BKK).
export function formatearMoneda(valor) {
  return valor ? new Intl.NumberFormat("es-CO").format(valor) : ""
}

export function parsearMoneda(texto) {
  return Number(String(texto).replace(/\./g, "").replace(/,/g, "")) || 0
}
